import { BillingDayOfMonthModel } from '../BillingDayOfMonth';
import { RelationshipFundingSourceModel } from '../RelationshipFundingSourceModel';
import * as timeModel from '../time';
export const fromDTO = (dto)=>({
        id: dto.id,
        billingDayOfMonth: BillingDayOfMonthModel.make(dto.billingDayOfMonth),
        customer: dto.customer,
        adHocChargeStatus: dto.adHocChargeStatus,
        invoiceStatus: dto.invoiceStatus,
        serviceStatus: dto.serviceStatus,
        isSample: dto.isSample,
        progressStatus: dto.progressStatus,
        progressStatusTimestamp: dto.progressStatusTimestamp,
        status: dto.status,
        suggestedCustomerName: dto.suggestedCustomerName,
        title: dto.title,
        vendor: dto.vendor,
        seller: dto.seller,
        fundingSource: dto.fundingSource && new RelationshipFundingSourceModel(dto.fundingSource),
        agreementStatusV2: dto.agreementStatusV2,
        hasAmendments: dto.hasAmendments,
        lastBilledDate: dto.lastBilledDate != null ? new Date(dto.lastBilledDate) : null,
        createdOn: new Date(dto.createdOn),
        effectiveDate: dto.effectiveDate && timeModel.fromDatestampArray(dto.effectiveDate),
        expirationDate: dto.expirationDate,
        draftId: dto.draftId,
        approvedAt: dto.approvedAt ? new Date(dto.approvedAt) : null
    });
